webpackJsonp([70144966829960],{

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutQuery = undefined;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Page = __webpack_require__(54);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Accreditations = __webpack_require__(37);
	
	var _Accreditations2 = _interopRequireDefault(_Accreditations);
	
	var _Container = __webpack_require__(19);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _theme = __webpack_require__(15);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _md = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageTitle = "Contact";
	var pageDesc = 'A well established company, we provide the very best in electrical, fire & security systems supplying only the best quality products and services. Established for over 20 years, with over 30 years experience, our success is based on referrals from our great many satisfied customers.';
	
	var Contact = function Contact(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    { id: 'contact', className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	    },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: pageTitle + ' | Castle Electrical Services Ltd',
	      meta: [{ name: 'description', content: pageDesc }, { property: 'og:title', content: '' + pageTitle }, { property: 'og:type', content: 'article' }, { property: 'og:description', content: pageDesc }, { property: 'og:url', content: ("https://johnwilson65.github.io") + '/contact' }, { property: 'og:site_name', content: 'Castle Electrical Services Ltd' }, { property: 'og:image', content: ("https://johnwilson65.github.io") + '/logos/logo-1024.png' }],
	      htmlAttributes: { 'lang': 'en' }
	    }),
	    _react2.default.createElement(_Accreditations2.default, { data: data }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        'h1',
	        {
	          className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]]) + ' ' + 'title'
	        },
	        'Contact Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        {
	          className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	        },
	        'Need a free no obligation quotation or advice, please use any of the following contact methods below to get in touch.'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]]) + ' ' + 'contact'
	        },
	        _react2.default.createElement(
	          'h3',
	          {
	            className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	          },
	          _react2.default.createElement(_md.MdEmail, null),
	          'Email: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:castle.electrical@btconnect.com', className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            },
	            'castle.electrical@btconnect.com'
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          {
	            className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	          },
	          _react2.default.createElement(_md.MdPhone, null),
	          'Landline: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'tel:01603507222', className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            },
	            '01603 507222'
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          {
	            className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	          },
	          _react2.default.createElement(_md.MdPhoneAndroid, null),
	          'Mobile: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'tel:07771512876', className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            },
	            '07771 512876'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        {
	          className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	        },
	        _react2.default.createElement(_md.MdLocationOn, null),
	        'Address:'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]]) + ' ' + 'map'
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]]) + ' ' + 'address'
	          },
	          _react2.default.createElement(
	            'address',
	            {
	              className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            },
	            '34 Wentworth Green',
	            _react2.default.createElement('br', {
	              className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            }),
	            'Norwich',
	            _react2.default.createElement('br', {
	              className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            }),
	            'NR4 6AE',
	            _react2.default.createElement('br', {
	              className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]]) + ' ' + 'map-detail'
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]]) + ' ' + 'map-responsive'
	            },
	            _react2.default.createElement('iframe', { src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2422.808067528319!2d1.2517475162300398!3d52.60924003736351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d9e158659f4a71%3A0x97256c26bc893bca!2sCastle+Electrical+Services+Ltd!5e0!3m2!1sen!2suk!4v1528968771729', width: '600', height: '450', frameBorder: '0', style: { border: 0 }, allowFullScreen: true, className: 'jsx-' + _Page2.default.__scopedHash + ' ' + _style2.default.dynamic([['3336173574', [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]]])
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: _Page2.default.__scopedHash,
	      css: _Page2.default.__scoped
	    }),
	    _react2.default.createElement(_style2.default, {
	      styleId: '3336173574',
	      css: ['.map-responsive.__jsx-style-dynamic-selector{overflow:hidden;padding-bottom:56.25%;position:relative;height:0;}', '.map-responsive.__jsx-style-dynamic-selector iframe.__jsx-style-dynamic-selector{left:0;top:0;width:100%;height:100%;position:absolute;}', '.map.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-flow:column;-ms-flex-flow:column;flex-flow:column;padding:0 1em;}', 'address.__jsx-style-dynamic-selector{font-style:normal;}', 'h3.__jsx-style-dynamic-selector{font-weight:normal;}', 'h3.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector{color:' + _theme2.default.colors.red + ';-webkit-text-decoration:none;text-decoration:none;}', 'h3.__jsx-style-dynamic-selector svg{width:2em;height:2em;margin-right:.2em;fill:' + _theme2.default.colors.red + ';}', '.address.__jsx-style-dynamic-selector{min-width:180px;}', '.map.__jsx-style-dynamic-selector .map-detail.__jsx-style-dynamic-selector{width:100%;}', '@media(min-width:' + _theme2.default.breakpoints.md + 'px){.map.__jsx-style-dynamic-selector{-webkit-flex-flow:row;-ms-flex-flow:row;flex-flow:row;}}'],
	      dynamic: [_theme2.default.colors.red, _theme2.default.colors.red, _theme2.default.breakpoints.md]
	    })
	  );
	};
	
	exports.default = Contact;
	var aboutQuery = exports.aboutQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-8adaaebc53ebd8b55448.js